import {
  Grid,
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel
} from '@chakra-ui/react'
import { FC, useState } from 'react'
import Swal from 'sweetalert2'

import useReabTimeline from '@hook/parametrization/use-reab-timeline'
import useAuth from '@hook/shared/use-auth'

import LayoutEmpty from '@component/Layout/Empty'
import LayoutLoader from '@component/Layout/Loader'

import ParametrizationCurveStore from '../CurvesView/CurveStore'
import ParametrizationChapariaReab from '../ReabConfig/ChapariaReab'
import ParametrizationFerragemReab from '../ReabConfig/FerragemReab'

const CronogramaReab: FC = () => {
  const { companies: authCompanies } = useAuth()
  const [lastIndex, setLastIndex] = useState(true)

  const { companieId, loading, isChange, createData } = useReabTimeline()
  const [tabIndex, setTabIndex] = useState(0)
  const handleTabsChange = (index: any) => {
    if (isChange) {
      if (lastIndex) {
        Swal.fire({
          title: 'Existe Alterações não salvas',
          text: 'Desejar Continuar?',
          icon: 'warning',
          showDenyButton: true,
          confirmButtonText: 'Salvar',
          denyButtonText: 'Não'
        }).then(result => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            createData()
            setTabIndex(index)
            setLastIndex(index)
          } else if (result.isDenied) {
            setLastIndex(!lastIndex)
          }
        })
      } else {
        setLastIndex(!lastIndex)
      }
    } else {
      setTabIndex(index)
    }
  }
  // "Selecione ao menos 1 empresa"
  return (
    <Grid w="95vw" bg="white" templateColumns="95vw">
      <Box overflow="auto" h="70vh">
        <Tabs
          index={tabIndex}
          variant="soft-rounded"
          colorScheme="green"
          onChange={handleTabsChange}
        >
          <TabList padding={2}>
            <Tab>Ferragem</Tab>
            <Tab>Chaparia</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              {loading ? (
                <LayoutLoader
                  title="Recuperando informações..."
                  message="Aguarde enquanto buscamos os dados no banco de dados"
                />
              ) : (
                <>
                  {authCompanies?.length === 0 ? (
                    <>
                      <>
                        <LayoutEmpty
                          type="chartEmpty"
                          title="É necessário pelo menos 1 Centro de Distribuição cadastrada no perfil"
                          message=""
                        />
                      </>
                    </>
                  ) : authCompanies?.length > 0 && companieId === '' ? (
                    <>
                      <LayoutEmpty
                        type="chartEmpty"
                        title="Selecione ao menos 1  Centro de Distribuição"
                        message="Filtre sua busca em cima para obter informações"
                      />
                    </>
                  ) : (
                    <>
                      <ParametrizationChapariaReab />
                    </>
                  )}
                </>
              )}
            </TabPanel>
            <TabPanel>
              {loading ? (
                <LayoutLoader
                  title="Recuperando informações..."
                  message="Aguarde enquanto buscamos os dados no banco de dados"
                />
              ) : (
                <>
                  {authCompanies?.length === 0 ? (
                    <>
                      <>
                        <LayoutEmpty
                          type="chartEmpty"
                          title="É necessário pelo menos 1 Centro de Distribuição cadastrada no perfil"
                          message=""
                        />
                      </>
                    </>
                  ) : authCompanies?.length > 0 && companieId === '' ? (
                    <>
                      <LayoutEmpty
                        type="chartEmpty"
                        title="Selecione ao menos 1  Centro de Distribuição"
                        message="Filtre sua busca em cima para obter informações"
                      />
                    </>
                  ) : (
                    <>
                      <ParametrizationFerragemReab />
                    </>
                  )}
                </>
              )}
            </TabPanel>

            <TabPanel>
              <ParametrizationCurveStore />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Grid>
  )
}

export default CronogramaReab
